import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["recipient", "link"];
import username from 'flarum/common/helpers/username';
import User from 'flarum/common/models/User';
import Group from 'flarum/common/models/Group';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class RecipientLabel extends Component {
  view(vnode) {
    const _this$attrs = this.attrs,
      {
        recipient,
        link
      } = _this$attrs,
      newAttrs = _objectWithoutProperties(_this$attrs, _excluded);
    newAttrs.style = newAttrs.style || {};
    newAttrs.className = classList('RecipientLabel', newAttrs == null ? void 0 : newAttrs.className);
    if (link && recipient instanceof User) {
      newAttrs.href = app.route.user(recipient);
    }
    let label;
    if (recipient instanceof User) {
      var _app$session;
      label = username(recipient);
      if (!newAttrs.href && recipient.id() !== (app == null || (_app$session = app.session) == null || (_app$session = _app$session.user) == null ? void 0 : _app$session.id())) {
        newAttrs.href = app.route.user(recipient);
      }
    } else if (recipient instanceof Group) {
      return m("span", {
        class: newAttrs.className
      }, recipient.namePlural());
    } else {
      newAttrs.className += ' none';
      label = app.translator.trans('core.lib.username.deleted_text');
    }
    return m(LinkButton, newAttrs, label);
  }
}
flarum.reg.add('fof-byobu', 'forum/pages/labels/RecipientLabel', RecipientLabel);